import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
state: {
    mode: localStorage.getItem("mode") ? localStorage.getItem("mode") : "theme-light is-not-ios is-loading",
    user: {},
    messages: {},
    video: {}
},
getters: {
    mode: state => {
        return state.mode
    },
    user: state => {
        return state.user
    },
    messages: state => {
        return state.messages
    },
    video: state => {
        return state.video
    }
},
mutations: {
    updateMode (state) {
      if(state.mode === "theme-dark is-not-ios is-loading"){
        state.mode = "theme-light is-not-ios is-loading"
        localStorage.setItem("mode", "theme-light is-not-ios is-loading")
      }
      else{
        state.mode = "theme-dark is-not-ios is-loading"
        localStorage.setItem("mode", "theme-dark is-not-ios is-loading")
      }
    },
    updateUser(state, user){
        state.user = user
    },
    updateMessages(state, messages){
        state.messages = messages
    },
    updateStateVideo(state, video){
        state.video = video
    }
  }
})